import { ref, readonly, onBeforeUnmount, inject } from "vue";
function e(e3) {
  function t2(e4, t3) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e4, this.code = t3;
  }
  return t2.prototype = new Error(), t2.prototype.name = e3, t2.prototype.constructor = t2, t2;
}
const t = e("LaunchDarklyUnexpectedResponseError"), n = e("LaunchDarklyInvalidEnvironmentIdError"), r = e("LaunchDarklyInvalidUserError"), o = e("LaunchDarklyInvalidEventKeyError"), i = e("LaunchDarklyInvalidArgumentError"), a = e("LaunchDarklyFlagFetchError");
for (var s = { LDUnexpectedResponseError: t, LDInvalidEnvironmentIdError: n, LDInvalidUserError: r, LDInvalidEventKeyError: o, LDInvalidArgumentError: i, LDInvalidDataError: e("LaunchDarklyInvalidDataError"), LDFlagFetchError: a, LDTimeoutError: e("LaunchDarklyTimeoutError"), isHttpErrorRecoverable: function(e3) {
  return !(e3 >= 400 && e3 < 500) || (400 === e3 || 408 === e3 || 429 === e3);
} }, c = function(e3) {
  var t2 = m(e3), n2 = t2[0], r2 = t2[1];
  return 3 * (n2 + r2) / 4 - r2;
}, u = function(e3) {
  var t2, n2, r2 = m(e3), o2 = r2[0], i2 = r2[1], a2 = new g(function(e4, t3, n3) {
    return 3 * (t3 + n3) / 4 - n3;
  }(0, o2, i2)), s2 = 0, c2 = i2 > 0 ? o2 - 4 : o2;
  for (n2 = 0; n2 < c2; n2 += 4)
    t2 = f[e3.charCodeAt(n2)] << 18 | f[e3.charCodeAt(n2 + 1)] << 12 | f[e3.charCodeAt(n2 + 2)] << 6 | f[e3.charCodeAt(n2 + 3)], a2[s2++] = t2 >> 16 & 255, a2[s2++] = t2 >> 8 & 255, a2[s2++] = 255 & t2;
  2 === i2 && (t2 = f[e3.charCodeAt(n2)] << 2 | f[e3.charCodeAt(n2 + 1)] >> 4, a2[s2++] = 255 & t2);
  1 === i2 && (t2 = f[e3.charCodeAt(n2)] << 10 | f[e3.charCodeAt(n2 + 1)] << 4 | f[e3.charCodeAt(n2 + 2)] >> 2, a2[s2++] = t2 >> 8 & 255, a2[s2++] = 255 & t2);
  return a2;
}, l = function(e3) {
  for (var t2, n2 = e3.length, r2 = n2 % 3, o2 = [], i2 = 16383, a2 = 0, s2 = n2 - r2; a2 < s2; a2 += i2)
    o2.push(h(e3, a2, a2 + i2 > s2 ? s2 : a2 + i2));
  1 === r2 ? (t2 = e3[n2 - 1], o2.push(d[t2 >> 2] + d[t2 << 4 & 63] + "==")) : 2 === r2 && (t2 = (e3[n2 - 2] << 8) + e3[n2 - 1], o2.push(d[t2 >> 10] + d[t2 >> 4 & 63] + d[t2 << 2 & 63] + "="));
  return o2.join("");
}, d = [], f = [], g = "undefined" != typeof Uint8Array ? Uint8Array : Array, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0; p < 64; ++p)
  d[p] = v[p], f[v.charCodeAt(p)] = p;
function m(e3) {
  var t2 = e3.length;
  if (t2 % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n2 = e3.indexOf("=");
  return -1 === n2 && (n2 = t2), [n2, n2 === t2 ? 0 : 4 - n2 % 4];
}
function h(e3, t2, n2) {
  for (var r2, o2, i2 = [], a2 = t2; a2 < n2; a2 += 3)
    r2 = (e3[a2] << 16 & 16711680) + (e3[a2 + 1] << 8 & 65280) + (255 & e3[a2 + 2]), i2.push(d[(o2 = r2) >> 18 & 63] + d[o2 >> 12 & 63] + d[o2 >> 6 & 63] + d[63 & o2]);
  return i2.join("");
}
f["-".charCodeAt(0)] = 62, f["_".charCodeAt(0)] = 63;
var y = { byteLength: c, toByteArray: u, fromByteArray: l }, w = Array.isArray, b = Object.keys, k = Object.prototype.hasOwnProperty, E = function e2(t2, n2) {
  if (t2 === n2)
    return true;
  if (t2 && n2 && "object" == typeof t2 && "object" == typeof n2) {
    var r2, o2, i2, a2 = w(t2), s = w(n2);
    if (a2 && s) {
      if ((o2 = t2.length) != n2.length)
        return false;
      for (r2 = o2; 0 != r2--; )
        if (!e2(t2[r2], n2[r2]))
          return false;
      return true;
    }
    if (a2 != s)
      return false;
    var c = t2 instanceof Date, u = n2 instanceof Date;
    if (c != u)
      return false;
    if (c && u)
      return t2.getTime() == n2.getTime();
    var l = t2 instanceof RegExp, d = n2 instanceof RegExp;
    if (l != d)
      return false;
    if (l && d)
      return t2.toString() == n2.toString();
    var f = b(t2);
    if ((o2 = f.length) !== b(n2).length)
      return false;
    for (r2 = o2; 0 != r2--; )
      if (!k.call(n2, f[r2]))
        return false;
    for (r2 = o2; 0 != r2--; )
      if (!e2(t2[i2 = f[r2]], n2[i2]))
        return false;
    return true;
  }
  return t2 != t2 && n2 != n2;
};
const D = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function x(e3) {
  const t2 = unescape(encodeURIComponent(e3));
  return y.fromByteArray(function(e4) {
    const t3 = [];
    for (let n2 = 0; n2 < e4.length; n2++)
      t3.push(e4.charCodeAt(n2));
    return t3;
  }(t2));
}
function C(e3, t2) {
  return Object.prototype.hasOwnProperty.call(e3, t2);
}
var P, S = { appendUrlPath: function(e3, t2) {
  return (e3.endsWith("/") ? e3.substring(0, e3.length - 1) : e3) + (t2.startsWith("/") ? "" : "/") + t2;
}, base64URLEncode: function(e3) {
  return x(e3).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}, btoa: x, clone: function(e3) {
  return JSON.parse(JSON.stringify(e3));
}, deepEquals: function(e3, t2) {
  return E(e3, t2);
}, extend: function(...e3) {
  return e3.reduce((e4, t2) => ({ ...e4, ...t2 }), {});
}, getLDUserAgentString: function(e3) {
  const t2 = e3.version || "?";
  return e3.userAgent + "/" + t2;
}, objectHasOwnProperty: C, onNextTick: function(e3) {
  setTimeout(e3, 0);
}, sanitizeContext: function(e3) {
  if (!e3)
    return e3;
  let t2;
  return null !== e3.kind && void 0 !== e3.kind || D.forEach((n2) => {
    const r2 = e3[n2];
    void 0 !== r2 && "string" != typeof r2 && (t2 = t2 || { ...e3 }, t2[n2] = String(r2));
  }), t2 || e3;
}, transformValuesToVersionedValues: function(e3) {
  const t2 = {};
  for (const n2 in e3)
    C(e3, n2) && (t2[n2] = { value: e3[n2], version: 0 });
  return t2;
}, transformVersionedValuesToValues: function(e3) {
  const t2 = {};
  for (const n2 in e3)
    C(e3, n2) && (t2[n2] = e3[n2].value);
  return t2;
}, wrapPromiseCallback: function(e3, t2) {
  const n2 = e3.then((e4) => (t2 && setTimeout(() => {
    t2(null, e4);
  }, 0), e4), (e4) => {
    if (!t2)
      return Promise.reject(e4);
    setTimeout(() => {
      t2(e4, null);
    }, 0);
  });
  return t2 ? void 0 : n2;
} }, I = new Uint8Array(16);
function O() {
  if (!P && !(P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto)))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return P(I);
}
var T = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function L(e3) {
  return "string" == typeof e3 && T.test(e3);
}
for (var U, R, A = [], j = 0; j < 256; ++j)
  A.push((j + 256).toString(16).substr(1));
function F(e3) {
  var t2 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n2 = (A[e3[t2 + 0]] + A[e3[t2 + 1]] + A[e3[t2 + 2]] + A[e3[t2 + 3]] + "-" + A[e3[t2 + 4]] + A[e3[t2 + 5]] + "-" + A[e3[t2 + 6]] + A[e3[t2 + 7]] + "-" + A[e3[t2 + 8]] + A[e3[t2 + 9]] + "-" + A[e3[t2 + 10]] + A[e3[t2 + 11]] + A[e3[t2 + 12]] + A[e3[t2 + 13]] + A[e3[t2 + 14]] + A[e3[t2 + 15]]).toLowerCase();
  if (!L(n2))
    throw TypeError("Stringified UUID is invalid");
  return n2;
}
var N = 0, $ = 0;
function V(e3) {
  if (!L(e3))
    throw TypeError("Invalid UUID");
  var t2, n2 = new Uint8Array(16);
  return n2[0] = (t2 = parseInt(e3.slice(0, 8), 16)) >>> 24, n2[1] = t2 >>> 16 & 255, n2[2] = t2 >>> 8 & 255, n2[3] = 255 & t2, n2[4] = (t2 = parseInt(e3.slice(9, 13), 16)) >>> 8, n2[5] = 255 & t2, n2[6] = (t2 = parseInt(e3.slice(14, 18), 16)) >>> 8, n2[7] = 255 & t2, n2[8] = (t2 = parseInt(e3.slice(19, 23), 16)) >>> 8, n2[9] = 255 & t2, n2[10] = (t2 = parseInt(e3.slice(24, 36), 16)) / 1099511627776 & 255, n2[11] = t2 / 4294967296 & 255, n2[12] = t2 >>> 24 & 255, n2[13] = t2 >>> 16 & 255, n2[14] = t2 >>> 8 & 255, n2[15] = 255 & t2, n2;
}
function M(e3, t2, n2) {
  function r2(e4, r3, o2, i2) {
    if ("string" == typeof e4 && (e4 = function(e5) {
      e5 = unescape(encodeURIComponent(e5));
      for (var t3 = [], n3 = 0; n3 < e5.length; ++n3)
        t3.push(e5.charCodeAt(n3));
      return t3;
    }(e4)), "string" == typeof r3 && (r3 = V(r3)), 16 !== r3.length)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var a2 = new Uint8Array(16 + e4.length);
    if (a2.set(r3), a2.set(e4, r3.length), (a2 = n2(a2))[6] = 15 & a2[6] | t2, a2[8] = 63 & a2[8] | 128, o2) {
      i2 = i2 || 0;
      for (var s = 0; s < 16; ++s)
        o2[i2 + s] = a2[s];
      return o2;
    }
    return F(a2);
  }
  try {
    r2.name = e3;
  } catch (e4) {
  }
  return r2.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r2.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r2;
}
function H(e3) {
  return 14 + (e3 + 64 >>> 9 << 4) + 1;
}
function q(e3, t2) {
  var n2 = (65535 & e3) + (65535 & t2);
  return (e3 >> 16) + (t2 >> 16) + (n2 >> 16) << 16 | 65535 & n2;
}
function z(e3, t2, n2, r2, o2, i2) {
  return q((a2 = q(q(t2, e3), q(r2, i2))) << (s = o2) | a2 >>> 32 - s, n2);
  var a2, s;
}
function K(e3, t2, n2, r2, o2, i2, a2) {
  return z(t2 & n2 | ~t2 & r2, e3, t2, o2, i2, a2);
}
function _(e3, t2, n2, r2, o2, i2, a2) {
  return z(t2 & r2 | n2 & ~r2, e3, t2, o2, i2, a2);
}
function J(e3, t2, n2, r2, o2, i2, a2) {
  return z(t2 ^ n2 ^ r2, e3, t2, o2, i2, a2);
}
function B(e3, t2, n2, r2, o2, i2, a2) {
  return z(n2 ^ (t2 | ~r2), e3, t2, o2, i2, a2);
}
var G = M("v3", 48, function(e3) {
  if ("string" == typeof e3) {
    var t2 = unescape(encodeURIComponent(e3));
    e3 = new Uint8Array(t2.length);
    for (var n2 = 0; n2 < t2.length; ++n2)
      e3[n2] = t2.charCodeAt(n2);
  }
  return function(e4) {
    for (var t3 = [], n3 = 32 * e4.length, r2 = "0123456789abcdef", o2 = 0; o2 < n3; o2 += 8) {
      var i2 = e4[o2 >> 5] >>> o2 % 32 & 255, a2 = parseInt(r2.charAt(i2 >>> 4 & 15) + r2.charAt(15 & i2), 16);
      t3.push(a2);
    }
    return t3;
  }(function(e4, t3) {
    e4[t3 >> 5] |= 128 << t3 % 32, e4[H(t3) - 1] = t3;
    for (var n3 = 1732584193, r2 = -271733879, o2 = -1732584194, i2 = 271733878, a2 = 0; a2 < e4.length; a2 += 16) {
      var s = n3, c = r2, u = o2, l = i2;
      n3 = K(n3, r2, o2, i2, e4[a2], 7, -680876936), i2 = K(i2, n3, r2, o2, e4[a2 + 1], 12, -389564586), o2 = K(o2, i2, n3, r2, e4[a2 + 2], 17, 606105819), r2 = K(r2, o2, i2, n3, e4[a2 + 3], 22, -1044525330), n3 = K(n3, r2, o2, i2, e4[a2 + 4], 7, -176418897), i2 = K(i2, n3, r2, o2, e4[a2 + 5], 12, 1200080426), o2 = K(o2, i2, n3, r2, e4[a2 + 6], 17, -1473231341), r2 = K(r2, o2, i2, n3, e4[a2 + 7], 22, -45705983), n3 = K(n3, r2, o2, i2, e4[a2 + 8], 7, 1770035416), i2 = K(i2, n3, r2, o2, e4[a2 + 9], 12, -1958414417), o2 = K(o2, i2, n3, r2, e4[a2 + 10], 17, -42063), r2 = K(r2, o2, i2, n3, e4[a2 + 11], 22, -1990404162), n3 = K(n3, r2, o2, i2, e4[a2 + 12], 7, 1804603682), i2 = K(i2, n3, r2, o2, e4[a2 + 13], 12, -40341101), o2 = K(o2, i2, n3, r2, e4[a2 + 14], 17, -1502002290), n3 = _(n3, r2 = K(r2, o2, i2, n3, e4[a2 + 15], 22, 1236535329), o2, i2, e4[a2 + 1], 5, -165796510), i2 = _(i2, n3, r2, o2, e4[a2 + 6], 9, -1069501632), o2 = _(o2, i2, n3, r2, e4[a2 + 11], 14, 643717713), r2 = _(r2, o2, i2, n3, e4[a2], 20, -373897302), n3 = _(n3, r2, o2, i2, e4[a2 + 5], 5, -701558691), i2 = _(i2, n3, r2, o2, e4[a2 + 10], 9, 38016083), o2 = _(o2, i2, n3, r2, e4[a2 + 15], 14, -660478335), r2 = _(r2, o2, i2, n3, e4[a2 + 4], 20, -405537848), n3 = _(n3, r2, o2, i2, e4[a2 + 9], 5, 568446438), i2 = _(i2, n3, r2, o2, e4[a2 + 14], 9, -1019803690), o2 = _(o2, i2, n3, r2, e4[a2 + 3], 14, -187363961), r2 = _(r2, o2, i2, n3, e4[a2 + 8], 20, 1163531501), n3 = _(n3, r2, o2, i2, e4[a2 + 13], 5, -1444681467), i2 = _(i2, n3, r2, o2, e4[a2 + 2], 9, -51403784), o2 = _(o2, i2, n3, r2, e4[a2 + 7], 14, 1735328473), n3 = J(n3, r2 = _(r2, o2, i2, n3, e4[a2 + 12], 20, -1926607734), o2, i2, e4[a2 + 5], 4, -378558), i2 = J(i2, n3, r2, o2, e4[a2 + 8], 11, -2022574463), o2 = J(o2, i2, n3, r2, e4[a2 + 11], 16, 1839030562), r2 = J(r2, o2, i2, n3, e4[a2 + 14], 23, -35309556), n3 = J(n3, r2, o2, i2, e4[a2 + 1], 4, -1530992060), i2 = J(i2, n3, r2, o2, e4[a2 + 4], 11, 1272893353), o2 = J(o2, i2, n3, r2, e4[a2 + 7], 16, -155497632), r2 = J(r2, o2, i2, n3, e4[a2 + 10], 23, -1094730640), n3 = J(n3, r2, o2, i2, e4[a2 + 13], 4, 681279174), i2 = J(i2, n3, r2, o2, e4[a2], 11, -358537222), o2 = J(o2, i2, n3, r2, e4[a2 + 3], 16, -722521979), r2 = J(r2, o2, i2, n3, e4[a2 + 6], 23, 76029189), n3 = J(n3, r2, o2, i2, e4[a2 + 9], 4, -640364487), i2 = J(i2, n3, r2, o2, e4[a2 + 12], 11, -421815835), o2 = J(o2, i2, n3, r2, e4[a2 + 15], 16, 530742520), n3 = B(n3, r2 = J(r2, o2, i2, n3, e4[a2 + 2], 23, -995338651), o2, i2, e4[a2], 6, -198630844), i2 = B(i2, n3, r2, o2, e4[a2 + 7], 10, 1126891415), o2 = B(o2, i2, n3, r2, e4[a2 + 14], 15, -1416354905), r2 = B(r2, o2, i2, n3, e4[a2 + 5], 21, -57434055), n3 = B(n3, r2, o2, i2, e4[a2 + 12], 6, 1700485571), i2 = B(i2, n3, r2, o2, e4[a2 + 3], 10, -1894986606), o2 = B(o2, i2, n3, r2, e4[a2 + 10], 15, -1051523), r2 = B(r2, o2, i2, n3, e4[a2 + 1], 21, -2054922799), n3 = B(n3, r2, o2, i2, e4[a2 + 8], 6, 1873313359), i2 = B(i2, n3, r2, o2, e4[a2 + 15], 10, -30611744), o2 = B(o2, i2, n3, r2, e4[a2 + 6], 15, -1560198380), r2 = B(r2, o2, i2, n3, e4[a2 + 13], 21, 1309151649), n3 = B(n3, r2, o2, i2, e4[a2 + 4], 6, -145523070), i2 = B(i2, n3, r2, o2, e4[a2 + 11], 10, -1120210379), o2 = B(o2, i2, n3, r2, e4[a2 + 2], 15, 718787259), r2 = B(r2, o2, i2, n3, e4[a2 + 9], 21, -343485551), n3 = q(n3, s), r2 = q(r2, c), o2 = q(o2, u), i2 = q(i2, l);
    }
    return [n3, r2, o2, i2];
  }(function(e4) {
    if (0 === e4.length)
      return [];
    for (var t3 = 8 * e4.length, n3 = new Uint32Array(H(t3)), r2 = 0; r2 < t3; r2 += 8)
      n3[r2 >> 5] |= (255 & e4[r2 / 8]) << r2 % 32;
    return n3;
  }(e3), 8 * e3.length));
}), W = G;
function X(e3, t2, n2, r2) {
  switch (e3) {
    case 0:
      return t2 & n2 ^ ~t2 & r2;
    case 1:
    case 3:
      return t2 ^ n2 ^ r2;
    case 2:
      return t2 & n2 ^ t2 & r2 ^ n2 & r2;
  }
}
function Q(e3, t2) {
  return e3 << t2 | e3 >>> 32 - t2;
}
var Y = M("v5", 80, function(e3) {
  var t2 = [1518500249, 1859775393, 2400959708, 3395469782], n2 = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if ("string" == typeof e3) {
    var r2 = unescape(encodeURIComponent(e3));
    e3 = [];
    for (var o2 = 0; o2 < r2.length; ++o2)
      e3.push(r2.charCodeAt(o2));
  } else
    Array.isArray(e3) || (e3 = Array.prototype.slice.call(e3));
  e3.push(128);
  for (var i2 = e3.length / 4 + 2, a2 = Math.ceil(i2 / 16), s = new Array(a2), c = 0; c < a2; ++c) {
    for (var u = new Uint32Array(16), l = 0; l < 16; ++l)
      u[l] = e3[64 * c + 4 * l] << 24 | e3[64 * c + 4 * l + 1] << 16 | e3[64 * c + 4 * l + 2] << 8 | e3[64 * c + 4 * l + 3];
    s[c] = u;
  }
  s[a2 - 1][14] = 8 * (e3.length - 1) / Math.pow(2, 32), s[a2 - 1][14] = Math.floor(s[a2 - 1][14]), s[a2 - 1][15] = 8 * (e3.length - 1) & 4294967295;
  for (var d = 0; d < a2; ++d) {
    for (var f = new Uint32Array(80), g = 0; g < 16; ++g)
      f[g] = s[d][g];
    for (var v = 16; v < 80; ++v)
      f[v] = Q(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
    for (var p = n2[0], m2 = n2[1], h2 = n2[2], y2 = n2[3], w2 = n2[4], b2 = 0; b2 < 80; ++b2) {
      var k2 = Math.floor(b2 / 20), E2 = Q(p, 5) + X(k2, m2, h2, y2) + w2 + t2[k2] + f[b2] >>> 0;
      w2 = y2, y2 = h2, h2 = Q(m2, 30) >>> 0, m2 = p, p = E2;
    }
    n2[0] = n2[0] + p >>> 0, n2[1] = n2[1] + m2 >>> 0, n2[2] = n2[2] + h2 >>> 0, n2[3] = n2[3] + y2 >>> 0, n2[4] = n2[4] + w2 >>> 0;
  }
  return [n2[0] >> 24 & 255, n2[0] >> 16 & 255, n2[0] >> 8 & 255, 255 & n2[0], n2[1] >> 24 & 255, n2[1] >> 16 & 255, n2[1] >> 8 & 255, 255 & n2[1], n2[2] >> 24 & 255, n2[2] >> 16 & 255, n2[2] >> 8 & 255, 255 & n2[2], n2[3] >> 24 & 255, n2[3] >> 16 & 255, n2[3] >> 8 & 255, 255 & n2[3], n2[4] >> 24 & 255, n2[4] >> 16 & 255, n2[4] >> 8 & 255, 255 & n2[4]];
}), Z = Y;
var ee = Object.freeze({ __proto__: null, v1: function(e3, t2, n2) {
  var r2 = t2 && n2 || 0, o2 = t2 || new Array(16), i2 = (e3 = e3 || {}).node || U, a2 = void 0 !== e3.clockseq ? e3.clockseq : R;
  if (null == i2 || null == a2) {
    var s = e3.random || (e3.rng || O)();
    null == i2 && (i2 = U = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), null == a2 && (a2 = R = 16383 & (s[6] << 8 | s[7]));
  }
  var c = void 0 !== e3.msecs ? e3.msecs : Date.now(), u = void 0 !== e3.nsecs ? e3.nsecs : $ + 1, l = c - N + (u - $) / 1e4;
  if (l < 0 && void 0 === e3.clockseq && (a2 = a2 + 1 & 16383), (l < 0 || c > N) && void 0 === e3.nsecs && (u = 0), u >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  N = c, $ = u, R = a2;
  var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
  o2[r2++] = d >>> 24 & 255, o2[r2++] = d >>> 16 & 255, o2[r2++] = d >>> 8 & 255, o2[r2++] = 255 & d;
  var f = c / 4294967296 * 1e4 & 268435455;
  o2[r2++] = f >>> 8 & 255, o2[r2++] = 255 & f, o2[r2++] = f >>> 24 & 15 | 16, o2[r2++] = f >>> 16 & 255, o2[r2++] = a2 >>> 8 | 128, o2[r2++] = 255 & a2;
  for (var g = 0; g < 6; ++g)
    o2[r2 + g] = i2[g];
  return t2 || F(o2);
}, v3: W, v4: function(e3, t2, n2) {
  var r2 = (e3 = e3 || {}).random || (e3.rng || O)();
  if (r2[6] = 15 & r2[6] | 64, r2[8] = 63 & r2[8] | 128, t2) {
    n2 = n2 || 0;
    for (var o2 = 0; o2 < 16; ++o2)
      t2[n2 + o2] = r2[o2];
    return t2;
  }
  return F(r2);
}, v5: Z, NIL: "00000000-0000-0000-0000-000000000000", version: function(e3) {
  if (!L(e3))
    throw TypeError("Invalid UUID");
  return parseInt(e3.substr(14, 1), 16);
}, validate: L, stringify: F, parse: V });
const te = ["debug", "info", "warn", "error", "none"];
var ne = { commonBasicLogger: function(e3, t2) {
  if (e3 && e3.destination && "function" != typeof e3.destination)
    throw new Error("destination for basicLogger was set to a non-function");
  function n2(e4) {
    return function(t3) {
      console && console[e4] && console[e4].call(console, t3);
    };
  }
  const r2 = e3 && e3.destination ? [e3.destination, e3.destination, e3.destination, e3.destination] : [n2("log"), n2("info"), n2("warn"), n2("error")], o2 = !(!e3 || !e3.destination), i2 = e3 && void 0 !== e3.prefix && null !== e3.prefix ? e3.prefix : "[LaunchDarkly] ";
  let a2 = 1;
  if (e3 && e3.level)
    for (let t3 = 0; t3 < te.length; t3++)
      te[t3] === e3.level && (a2 = t3);
  function s(e4, n3, a3) {
    if (a3.length < 1)
      return;
    let s2;
    const c2 = o2 ? n3 + ": " + i2 : i2;
    if (1 !== a3.length && t2) {
      const e5 = [...a3];
      e5[0] = c2 + e5[0], s2 = t2(...e5);
    } else
      s2 = c2 + a3[0];
    try {
      r2[e4](s2);
    } catch (e5) {
      console && console.log && console.log("[LaunchDarkly] Configured logger's " + n3 + " method threw an exception: " + e5);
    }
  }
  const c = {};
  for (let e4 = 0; e4 < te.length; e4++) {
    const t3 = te[e4];
    if ("none" !== t3)
      if (e4 < a2)
        c[t3] = () => {
        };
      else {
        const n3 = e4;
        c[t3] = function() {
          s(n3, t3, arguments);
        };
      }
  }
  return c;
}, validateLogger: function(e3) {
  te.forEach((t2) => {
    if ("none" !== t2 && (!e3[t2] || "function" != typeof e3[t2]))
      throw new Error("Provided logger instance must support logger." + t2 + "(...) method");
  });
} };
function re(e3) {
  return e3 && e3.message ? e3.message : "string" == typeof e3 || e3 instanceof String ? e3 : JSON.stringify(e3);
}
const oe = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initializing-the-client for instructions on SDK initialization.";
var ie = { bootstrapInvalid: function() {
  return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
}, bootstrapOldFormat: function() {
  return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + oe;
}, clientInitialized: function() {
  return "LaunchDarkly client initialized";
}, clientNotReady: function() {
  return "LaunchDarkly client is not ready";
}, debugEnqueueingEvent: function(e3) {
  return 'enqueueing "' + e3 + '" event';
}, debugPostingDiagnosticEvent: function(e3) {
  return "sending diagnostic event (" + e3.kind + ")";
}, debugPostingEvents: function(e3) {
  return "sending " + e3 + " events";
}, debugStreamDelete: function(e3) {
  return 'received streaming deletion for flag "' + e3 + '"';
}, debugStreamDeleteIgnored: function(e3) {
  return 'received streaming deletion for flag "' + e3 + '" but ignored due to version check';
}, debugStreamPatch: function(e3) {
  return 'received streaming update for flag "' + e3 + '"';
}, debugStreamPatchIgnored: function(e3) {
  return 'received streaming update for flag "' + e3 + '" but ignored due to version check';
}, debugStreamPing: function() {
  return "received ping message from stream";
}, debugPolling: function(e3) {
  return "polling for feature flags at " + e3;
}, debugStreamPut: function() {
  return "received streaming update for all flags";
}, deprecated: function(e3, t2) {
  return t2 ? '"' + e3 + '" is deprecated, please use "' + t2 + '"' : '"' + e3 + '" is deprecated';
}, environmentNotFound: function() {
  return "Environment not found. Double check that you specified a valid environment/client-side ID." + oe;
}, environmentNotSpecified: function() {
  return "No environment/client-side ID was specified." + oe;
}, errorFetchingFlags: function(e3) {
  return "Error fetching flag settings: " + re(e3);
}, eventCapacityExceeded: function() {
  return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
}, eventWithoutContext: function() {
  return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
}, httpErrorMessage: function(e3, t2, n2) {
  return "Received error " + e3 + (401 === e3 ? " (invalid SDK key)" : "") + " for " + t2 + " - " + (s.isHttpErrorRecoverable(e3) ? n2 : "giving up permanently");
}, httpUnavailable: function() {
  return "Cannot make HTTP requests in this environment." + oe;
}, identifyDisabled: function() {
  return "identify() has no effect here; it must be called on the main client instance";
}, inspectorMethodError: (e3, t2) => `an inspector: "${t2}" of type: "${e3}" generated an exception`, invalidContentType: function(e3) {
  return 'Expected application/json content type but got "' + e3 + '"';
}, invalidData: function() {
  return "Invalid data received from LaunchDarkly; connection may have been interrupted";
}, invalidInspector: (e3, t2) => `an inspector: "${t2}" of an invalid type (${e3}) was configured`, invalidKey: function() {
  return "Event key must be a string";
}, invalidMetricValue: (e3) => `The track function was called with a non-numeric "metricValue" (${e3}), only numeric metric values are supported.`, invalidContext: function() {
  return "Invalid context specified." + oe;
}, invalidTagValue: (e3) => `Config option "${e3}" must only contain letters, numbers, ., _ or -.`, localStorageUnavailable: function(e3) {
  return "local storage is unavailable: " + re(e3);
}, networkError: (e3) => "network error" + (e3 ? " (" + e3 + ")" : ""), optionBelowMinimum: (e3, t2, n2) => 'Config option "' + e3 + '" was set to ' + t2 + ", changing to minimum value of " + n2, streamClosing: function() {
  return "Closing stream connection";
}, streamConnecting: function(e3) {
  return "Opening stream connection to " + e3;
}, streamError: function(e3, t2) {
  return "Error on stream connection: " + re(e3) + ", will continue retrying after " + t2 + " milliseconds.";
}, tagValueTooLong: (e3) => `Value of "${e3}" was longer than 64 characters and was discarded.`, unknownCustomEventKey: function(e3) {
  return 'Custom event "' + e3 + '" does not exist';
}, unknownOption: (e3) => 'Ignoring unknown config option "' + e3 + '"', contextNotSpecified: function() {
  return "No context specified." + oe;
}, unrecoverableStreamError: (e3) => `Error on stream connection ${re(e3)}, giving up permanently`, wrongOptionType: (e3, t2, n2) => 'Config option "' + e3 + '" should be of type ' + t2 + ", got " + n2 + ", using default value", wrongOptionTypeBoolean: (e3, t2) => 'Config option "' + e3 + '" should be a boolean, got ' + t2 + ", converting to boolean" };
const { validateLogger: ae } = ne, se = { baseUrl: { default: "https://app.launchdarkly.com" }, streamUrl: { default: "https://clientstream.launchdarkly.com" }, eventsUrl: { default: "https://events.launchdarkly.com" }, sendEvents: { default: true }, streaming: { type: "boolean" }, sendLDHeaders: { default: true }, requestHeaderTransform: { type: "function" }, sendEventsOnlyForVariation: { default: false }, useReport: { default: false }, evaluationReasons: { default: false }, eventCapacity: { default: 100, minimum: 1 }, flushInterval: { default: 2e3, minimum: 2e3 }, samplingInterval: { default: 0, minimum: 0 }, streamReconnectDelay: { default: 1e3, minimum: 0 }, allAttributesPrivate: { default: false }, privateAttributes: { default: [] }, bootstrap: { type: "string|object" }, diagnosticRecordingInterval: { default: 9e5, minimum: 2e3 }, diagnosticOptOut: { default: false }, wrapperName: { type: "string" }, wrapperVersion: { type: "string" }, stateProvider: { type: "object" }, application: { validator: function(e3, t2, n2) {
  const r2 = {};
  t2.id && (r2.id = le(`${e3}.id`, t2.id, n2));
  t2.version && (r2.version = le(`${e3}.version`, t2.version, n2));
  return r2;
} }, inspectors: { default: [] } }, ce = /^(\w|\.|-)+$/;
function ue(e3) {
  return e3 && e3.replace(/\/+$/, "");
}
function le(e3, t2, n2) {
  if ("string" == typeof t2 && t2.match(ce)) {
    if (!(t2.length > 64))
      return t2;
    n2.warn(ie.tagValueTooLong(e3));
  } else
    n2.warn(ie.invalidTagValue(e3));
}
var de = { baseOptionDefs: se, validate: function(e3, t2, n2, r2) {
  const o2 = S.extend({ logger: { default: r2 } }, se, n2), i2 = {};
  function a2(e4) {
    S.onNextTick(() => {
      t2 && t2.maybeReportError(new s.LDInvalidArgumentError(e4));
    });
  }
  let c = S.extend({}, e3 || {});
  return function(e4) {
    const t3 = e4;
    Object.keys(i2).forEach((e5) => {
      if (void 0 !== t3[e5]) {
        const n3 = i2[e5];
        r2 && r2.warn(ie.deprecated(e5, n3)), n3 && (void 0 === t3[n3] && (t3[n3] = t3[e5]), delete t3[e5]);
      }
    });
  }(c), c = function(e4) {
    const t3 = S.extend({}, e4);
    return Object.keys(o2).forEach((e5) => {
      void 0 !== t3[e5] && null !== t3[e5] || (t3[e5] = o2[e5] && o2[e5].default);
    }), t3;
  }(c), c = function(e4) {
    const t3 = S.extend({}, e4), n3 = (e5) => {
      if (null === e5)
        return "any";
      if (void 0 === e5)
        return;
      if (Array.isArray(e5))
        return "array";
      const t4 = typeof e5;
      return "boolean" === t4 || "string" === t4 || "number" === t4 || "function" === t4 ? t4 : "object";
    };
    return Object.keys(e4).forEach((i3) => {
      const s = e4[i3];
      if (null != s) {
        const c2 = o2[i3];
        if (void 0 === c2)
          a2(ie.unknownOption(i3));
        else {
          const o3 = c2.type || n3(c2.default), u = c2.validator;
          if (u) {
            const n4 = u(i3, e4[i3], r2);
            void 0 !== n4 ? t3[i3] = n4 : delete t3[i3];
          } else if ("any" !== o3) {
            const e5 = o3.split("|"), r3 = n3(s);
            e5.indexOf(r3) < 0 ? "boolean" === o3 ? (t3[i3] = !!s, a2(ie.wrongOptionTypeBoolean(i3, r3))) : (a2(ie.wrongOptionType(i3, o3, r3)), t3[i3] = c2.default) : "number" === r3 && void 0 !== c2.minimum && s < c2.minimum && (a2(ie.optionBelowMinimum(i3, s, c2.minimum)), t3[i3] = c2.minimum);
          }
        }
      }
    }), t3.baseUrl = ue(t3.baseUrl), t3.streamUrl = ue(t3.streamUrl), t3.eventsUrl = ue(t3.eventsUrl), t3;
  }(c), ae(c.logger), c;
}, getTags: function(e3) {
  const t2 = {};
  return e3 && (e3.application && void 0 !== e3.application.id && null !== e3.application.id && (t2["application-id"] = [e3.application.id]), e3.application && void 0 !== e3.application.version && null !== e3.application.id && (t2["application-version"] = [e3.application.version])), t2;
} };
const { getLDUserAgentString: fe } = S;
var ge = { getLDHeaders: function(e3, t2) {
  if (t2 && !t2.sendLDHeaders)
    return {};
  const n2 = {};
  n2[e3.userAgentHeaderName || "User-Agent"] = fe(e3), t2 && t2.wrapperName && (n2["X-LaunchDarkly-Wrapper"] = t2.wrapperVersion ? t2.wrapperName + "/" + t2.wrapperVersion : t2.wrapperName);
  const r2 = de.getTags(t2), o2 = Object.keys(r2);
  return o2.length && (n2["x-launchdarkly-tags"] = o2.sort().map((e4) => Array.isArray(r2[e4]) ? r2[e4].sort().map((t3) => `${e4}/${t3}`) : [`${e4}/${r2[e4]}`]).reduce((e4, t3) => e4.concat(t3), []).join(" ")), n2;
}, transformHeaders: function(e3, t2) {
  return t2 && t2.requestHeaderTransform ? t2.requestHeaderTransform({ ...e3 }) : e3;
} };
const { v1: ve } = ee, { getLDHeaders: pe, transformHeaders: me } = ge;
var he = function(e3, t2, n2) {
  const r2 = S.extend({ "Content-Type": "application/json" }, pe(e3, n2)), o2 = {};
  return o2.sendEvents = (t3, o3, i2) => {
    if (!e3.httpRequest)
      return Promise.resolve();
    const a2 = JSON.stringify(t3), c = i2 ? null : ve();
    return function t4(u) {
      const l = i2 ? r2 : S.extend({}, r2, { "X-LaunchDarkly-Event-Schema": "4", "X-LaunchDarkly-Payload-ID": c });
      return e3.httpRequest("POST", o3, me(l, n2), a2).promise.then((e4) => {
        if (e4)
          return e4.status >= 400 && s.isHttpErrorRecoverable(e4.status) && u ? t4(false) : function(e5) {
            const t5 = { status: e5.status }, n3 = e5.header("date");
            if (n3) {
              const e6 = Date.parse(n3);
              e6 && (t5.serverTime = e6);
            }
            return t5;
          }(e4);
      }).catch(() => u ? t4(false) : Promise.reject());
    }(true).catch(() => {
    });
  }, o2;
};
const { commonBasicLogger: ye } = ne;
function we(e3) {
  return "string" == typeof e3 && "kind" !== e3 && e3.match(/^(\w|\.|-)+$/);
}
function be(e3) {
  return e3.includes("%") || e3.includes(":") ? e3.replace(/%/g, "%25").replace(/:/g, "%3A") : e3;
}
var ke = { checkContext: function(e3, t2) {
  if (e3) {
    if (t2 && (void 0 === e3.kind || null === e3.kind))
      return void 0 !== e3.key && null !== e3.key;
    const n2 = e3.key, r2 = void 0 === e3.kind ? "user" : e3.kind, o2 = we(r2), i2 = "multi" === r2 || null != n2 && "" !== n2;
    if ("multi" === r2) {
      const t3 = Object.keys(e3).filter((e4) => "kind" !== e4);
      return i2 && t3.every((e4) => we(e4)) && t3.every((t4) => {
        const n3 = e3[t4].key;
        return null != n3 && "" !== n3;
      });
    }
    return i2 && o2;
  }
  return false;
}, getContextKeys: function(e3, t2 = ye()) {
  if (!e3)
    return;
  const n2 = {}, { kind: r2, key: o2 } = e3;
  switch (r2) {
    case void 0:
      n2.user = `${o2}`;
      break;
    case "multi":
      Object.entries(e3).filter(([e4]) => "kind" !== e4).forEach(([e4, t3]) => {
        t3 && t3.key && (n2[e4] = t3.key);
      });
      break;
    case null:
      t2.warn(`null is not a valid context kind: ${e3}`);
      break;
    case "":
      t2.warn(`'' is not a valid context kind: ${e3}`);
      break;
    default:
      n2[r2] = `${o2}`;
  }
  return n2;
}, getContextKinds: function(e3) {
  return e3 ? null === e3.kind || void 0 === e3.kind ? ["user"] : "multi" !== e3.kind ? [e3.kind] : Object.keys(e3).filter((e4) => "kind" !== e4) : [];
}, getCanonicalKey: function(e3) {
  if (e3) {
    if ((void 0 === e3.kind || null === e3.kind || "user" === e3.kind) && e3.key)
      return e3.key;
    if ("multi" !== e3.kind && e3.key)
      return `${e3.kind}:${be(e3.key)}`;
    if ("multi" === e3.kind)
      return Object.keys(e3).sort().filter((e4) => "kind" !== e4).map((t2) => `${t2}:${be(e3[t2].key)}`).join(":");
  }
} };
const { getContextKinds: Ee } = ke;
var De = function() {
  const e3 = {};
  let t2 = 0, n2 = 0, r2 = {}, o2 = {};
  return e3.summarizeEvent = (e4) => {
    if ("feature" === e4.kind) {
      const i2 = e4.key + ":" + (null !== e4.variation && void 0 !== e4.variation ? e4.variation : "") + ":" + (null !== e4.version && void 0 !== e4.version ? e4.version : ""), a2 = r2[i2];
      let s = o2[e4.key];
      s || (s = /* @__PURE__ */ new Set(), o2[e4.key] = s), function(e5) {
        return e5.context ? Ee(e5.context) : e5.contextKeys ? Object.keys(e5.contextKeys) : [];
      }(e4).forEach((e5) => s.add(e5)), a2 ? a2.count = a2.count + 1 : r2[i2] = { count: 1, key: e4.key, version: e4.version, variation: e4.variation, value: e4.value, default: e4.default }, (0 === t2 || e4.creationDate < t2) && (t2 = e4.creationDate), e4.creationDate > n2 && (n2 = e4.creationDate);
    }
  }, e3.getSummary = () => {
    const e4 = {};
    let i2 = true;
    for (const t3 of Object.values(r2)) {
      let n3 = e4[t3.key];
      n3 || (n3 = { default: t3.default, counters: [], contextKinds: [...o2[t3.key]] }, e4[t3.key] = n3);
      const r3 = { value: t3.value, count: t3.count };
      void 0 !== t3.variation && null !== t3.variation && (r3.variation = t3.variation), void 0 !== t3.version && null !== t3.version ? r3.version = t3.version : r3.unknown = true, n3.counters.push(r3), i2 = false;
    }
    return i2 ? null : { startDate: t2, endDate: n2, features: e4 };
  }, e3.clearSummary = () => {
    t2 = 0, n2 = 0, r2 = {}, o2 = {};
  }, e3;
};
function xe(e3) {
  return e3.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Ce(e3) {
  return (e3.startsWith("/") ? e3.substring(1) : e3).split("/").map((e4) => e4.indexOf("~") >= 0 ? e4.replace(/~1/g, "/").replace(/~0/g, "~") : e4);
}
function Pe(e3) {
  return !e3.startsWith("/");
}
function Se(e3, t2) {
  const n2 = Pe(e3), r2 = Pe(t2);
  if (n2 && r2)
    return e3 === t2;
  if (n2) {
    const n3 = Ce(t2);
    return 1 === n3.length && e3 === n3[0];
  }
  if (r2) {
    const n3 = Ce(e3);
    return 1 === n3.length && t2 === n3[0];
  }
  return e3 === t2;
}
function Ie(e3) {
  return `/${xe(e3)}`;
}
var Oe = { cloneExcluding: function(e3, t2) {
  const n2 = [], r2 = {}, o2 = [];
  for (n2.push(...Object.keys(e3).map((t3) => ({ key: t3, ptr: Ie(t3), source: e3, parent: r2, visited: [e3] }))); n2.length; ) {
    const e4 = n2.pop();
    if (t2.some((t3) => Se(t3, e4.ptr)))
      o2.push(e4.ptr);
    else {
      const t3 = e4.source[e4.key];
      if (null === t3)
        e4.parent[e4.key] = t3;
      else if (Array.isArray(t3))
        e4.parent[e4.key] = [...t3];
      else if ("object" == typeof t3) {
        if (e4.visited.includes(t3))
          continue;
        e4.parent[e4.key] = {}, n2.push(...Object.keys(t3).map((n3) => {
          return { key: n3, ptr: (r3 = e4.ptr, o3 = xe(n3), `${r3}/${o3}`), source: t3, parent: e4.parent[e4.key], visited: [...e4.visited, t3] };
          var r3, o3;
        }));
      } else
        e4.parent[e4.key] = t3;
    }
  }
  return { cloned: r2, excluded: o2.sort() };
}, compare: Se, literalToReference: Ie };
var Te = function(e3) {
  const t2 = {}, n2 = e3.allAttributesPrivate, r2 = e3.privateAttributes || [], o2 = ["key", "kind", "_meta", "anonymous"], i2 = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"], a2 = (e4, t3) => {
    if ("object" != typeof e4 || null === e4 || Array.isArray(e4))
      return;
    const { cloned: i3, excluded: a3 } = Oe.cloneExcluding(e4, ((e5, t4) => (n2 || t4 && e5.anonymous ? Object.keys(e5) : [...r2, ...e5._meta && e5._meta.privateAttributes || []]).filter((e6) => !o2.some((t5) => Oe.compare(e6, t5))))(e4, t3));
    return i3.key = String(i3.key), a3.length && (i3._meta || (i3._meta = {}), i3._meta.redactedAttributes = a3), i3._meta && (delete i3._meta.privateAttributes, 0 === Object.keys(i3._meta).length && delete i3._meta), void 0 !== i3.anonymous && (i3.anonymous = !!i3.anonymous), i3;
  };
  return t2.filter = (e4, t3 = false) => void 0 === e4.kind || null === e4.kind ? a2(((e5) => {
    const t4 = { ...e5.custom || {}, kind: "user", key: e5.key };
    void 0 !== e5.anonymous && (t4.anonymous = !!e5.anonymous);
    for (const n3 of i2)
      delete t4[n3], void 0 !== e5[n3] && null !== e5[n3] && (t4[n3] = String(e5[n3]));
    return void 0 !== e5.privateAttributeNames && null !== e5.privateAttributeNames && (t4._meta = t4._meta || {}, t4._meta.privateAttributes = e5.privateAttributeNames.map((e6) => e6.startsWith("/") ? Oe.literalToReference(e6) : e6)), t4;
  })(e4), t3) : "multi" === e4.kind ? ((e5, t4) => {
    const n3 = { kind: e5.kind }, r3 = Object.keys(e5);
    for (const o3 of r3)
      if ("kind" !== o3) {
        const r4 = a2(e5[o3], t4);
        r4 && (n3[o3] = r4);
      }
    return n3;
  })(e4, t3) : a2(e4, t3), t2;
};
const { getContextKeys: Le } = ke;
var Ue = function(e3, t2, n2, r2 = null, o2 = null, i2 = null) {
  const a2 = {}, c = i2 || he(e3, n2, t2), u = S.appendUrlPath(t2.eventsUrl, "/events/bulk/" + n2), l = De(), d = Te(t2), f = t2.samplingInterval, g = t2.eventCapacity, v = t2.flushInterval, p = t2.logger;
  let m2, h2 = [], y2 = 0, w2 = false, b2 = false;
  function k2() {
    return 0 === f || 0 === Math.floor(Math.random() * f);
  }
  function E2(e4) {
    const t3 = S.extend({}, e4);
    return "identify" === e4.kind ? t3.context = d.filter(e4.context) : "feature" === e4.kind ? t3.context = d.filter(e4.context, true) : (t3.contextKeys = Le(e4.context, p), delete t3.context), "feature" === e4.kind && (delete t3.trackEvents, delete t3.debugEventsUntilDate), t3;
  }
  function D2(e4) {
    h2.length < g ? (h2.push(e4), b2 = false) : (b2 || (b2 = true, p.warn(ie.eventCapacityExceeded())), r2 && r2.incrementDroppedEvents());
  }
  return a2.enqueue = function(e4) {
    if (w2)
      return;
    let t3 = false, n3 = false;
    var r3;
    if (l.summarizeEvent(e4), "feature" === e4.kind ? k2() && (t3 = !!e4.trackEvents, n3 = !!(r3 = e4).debugEventsUntilDate && r3.debugEventsUntilDate > y2 && r3.debugEventsUntilDate > new Date().getTime()) : t3 = k2(), t3 && D2(E2(e4)), n3) {
      const t4 = S.extend({}, e4, { kind: "debug" });
      t4.context = d.filter(t4.context), delete t4.trackEvents, delete t4.debugEventsUntilDate, D2(t4);
    }
  }, a2.flush = function() {
    if (w2)
      return Promise.resolve();
    const e4 = h2, t3 = l.getSummary();
    return l.clearSummary(), t3 && (t3.kind = "summary", e4.push(t3)), r2 && r2.setEventsInLastBatch(e4.length), 0 === e4.length ? Promise.resolve() : (h2 = [], p.debug(ie.debugPostingEvents(e4.length)), c.sendEvents(e4, u).then((e5) => {
      e5 && (e5.serverTime && (y2 = e5.serverTime), s.isHttpErrorRecoverable(e5.status) || (w2 = true), e5.status >= 400 && S.onNextTick(() => {
        o2.maybeReportError(new s.LDUnexpectedResponseError(ie.httpErrorMessage(e5.status, "event posting", "some events were dropped")));
      }));
    }));
  }, a2.start = function() {
    const e4 = () => {
      a2.flush(), m2 = setTimeout(e4, v);
    };
    m2 = setTimeout(e4, v);
  }, a2.stop = function() {
    clearTimeout(m2);
  }, a2;
};
var Re = function(e3) {
  const t2 = {}, n2 = {};
  return t2.on = function(e4, t3, r2) {
    n2[e4] = n2[e4] || [], n2[e4] = n2[e4].concat({ handler: t3, context: r2 });
  }, t2.off = function(e4, t3, r2) {
    if (n2[e4])
      for (let o2 = 0; o2 < n2[e4].length; o2++)
        n2[e4][o2].handler === t3 && n2[e4][o2].context === r2 && (n2[e4] = n2[e4].slice(0, o2).concat(n2[e4].slice(o2 + 1)));
  }, t2.emit = function(e4) {
    if (!n2[e4])
      return;
    const t3 = n2[e4].slice(0);
    for (let e5 = 0; e5 < t3.length; e5++)
      t3[e5].handler.apply(t3[e5].context, Array.prototype.slice.call(arguments, 1));
  }, t2.getEvents = function() {
    return Object.keys(n2);
  }, t2.getEventListenerCount = function(e4) {
    return n2[e4] ? n2[e4].length : 0;
  }, t2.maybeReportError = function(t3) {
    t3 && (n2["error"] ? this.emit("error", t3) : (e3 || console).error(t3.message));
  }, t2;
};
const Ae = "ready", je = "initialized", Fe = "failed";
var Ne = function(e3) {
  let t2 = false, n2 = false, r2 = null, o2 = null;
  const i2 = new Promise((t3) => {
    const n3 = () => {
      e3.off(Ae, n3), t3();
    };
    e3.on(Ae, n3);
  }).catch(() => {
  });
  return { getInitializationPromise: () => o2 || (t2 ? Promise.resolve() : n2 ? Promise.reject(r2) : (o2 = new Promise((t3, n3) => {
    const r3 = () => {
      e3.off(je, r3), t3();
    }, o3 = (t4) => {
      e3.off(Fe, o3), n3(t4);
    };
    e3.on(je, r3), e3.on(Fe, o3);
  }), o2)), getReadyPromise: () => i2, signalSuccess: () => {
    t2 || n2 || (t2 = true, e3.emit(je), e3.emit(Ae));
  }, signalFailure: (o3) => {
    t2 || n2 || (n2 = true, r2 = o3, e3.emit(Fe, o3), e3.emit(Ae)), e3.maybeReportError(o3);
  } };
};
var $e = function(e3, t2, n2, r2) {
  const o2 = {};
  function i2() {
    let e4 = "";
    const o3 = r2.getContext();
    return o3 && (e4 = n2 || S.btoa(JSON.stringify(o3))), "ld:" + t2 + ":" + e4;
  }
  return o2.loadFlags = () => e3.get(i2()).then((e4) => {
    if (null == e4)
      return null;
    try {
      let t3 = JSON.parse(e4);
      if (t3) {
        const e5 = t3.$schema;
        void 0 === e5 || e5 < 1 ? t3 = S.transformValuesToVersionedValues(t3) : delete t3.$schema;
      }
      return t3;
    } catch (e5) {
      return o2.clearFlags().then(() => null);
    }
  }), o2.saveFlags = (t3) => {
    const n3 = S.extend({}, t3, { $schema: 1 });
    return e3.set(i2(), JSON.stringify(n3));
  }, o2.clearFlags = () => e3.clear(i2()), o2;
};
var Ve = function(e3, t2) {
  const n2 = {};
  let r2 = false;
  const o2 = (e4) => {
    r2 || (r2 = true, t2.warn(ie.localStorageUnavailable(e4)));
  };
  return n2.isEnabled = () => !!e3, n2.get = (t3) => new Promise((n3) => {
    e3 ? e3.get(t3).then(n3).catch((e4) => {
      o2(e4), n3(void 0);
    }) : n3(void 0);
  }), n2.set = (t3, n3) => new Promise((r3) => {
    e3 ? e3.set(t3, n3).then(() => r3(true)).catch((e4) => {
      o2(e4), r3(false);
    }) : r3(false);
  }), n2.clear = (t3) => new Promise((n3) => {
    e3 ? e3.clear(t3).then(() => n3(true)).catch((e4) => {
      o2(e4), n3(false);
    }) : n3(false);
  }), n2;
};
const { appendUrlPath: Me, base64URLEncode: He, objectHasOwnProperty: qe } = S, { getLDHeaders: ze, transformHeaders: Ke } = ge, { isHttpErrorRecoverable: _e } = s;
var Je = function(e3, t2, n2, r2) {
  const o2 = t2.streamUrl, i2 = t2.logger, a2 = {}, s = Me(o2, "/eval/" + n2), c = t2.useReport, u = t2.evaluationReasons, l = t2.streamReconnectDelay, d = ze(e3, t2);
  let f, g = false, v = null, p = null, m2 = null, h2 = null, y2 = null, w2 = 0;
  function b2() {
    const e4 = (t3 = function() {
      const e5 = l * Math.pow(2, w2);
      return e5 > 3e4 ? 3e4 : e5;
    }(), t3 - Math.trunc(0.5 * Math.random() * t3));
    var t3;
    return w2 += 1, e4;
  }
  function k2(e4) {
    if (e4.status && "number" == typeof e4.status && !_e(e4.status))
      return x2(), i2.error(ie.unrecoverableStreamError(e4)), void (p && (clearTimeout(p), p = null));
    const t3 = b2();
    g || (i2.warn(ie.streamError(e4, t3)), g = true), C2(false), x2(), E2(t3);
  }
  function E2(e4) {
    p || (e4 ? p = setTimeout(D2, e4) : D2());
  }
  function D2() {
    let r3;
    p = null;
    let a3 = "";
    const l2 = { headers: d, readTimeoutMillis: 3e5 };
    if (e3.eventSourceFactory) {
      null != h2 && (a3 = "h=" + h2), c ? e3.eventSourceAllowsReport ? (r3 = s, l2.method = "REPORT", l2.headers["Content-Type"] = "application/json", l2.body = JSON.stringify(m2)) : (r3 = Me(o2, "/ping/" + n2), a3 = "") : r3 = s + "/" + He(JSON.stringify(m2)), l2.headers = Ke(l2.headers, t2), u && (a3 = a3 + (a3 ? "&" : "") + "withReasons=true"), r3 = r3 + (a3 ? "?" : "") + a3, x2(), i2.info(ie.streamConnecting(r3)), f = new Date().getTime(), v = e3.eventSourceFactory(r3, l2);
      for (const e4 in y2)
        qe(y2, e4) && v.addEventListener(e4, y2[e4]);
      v.onerror = k2, v.onopen = () => {
        w2 = 0;
      };
    }
  }
  function x2() {
    v && (i2.info(ie.streamClosing()), v.close(), v = null);
  }
  function C2(e4) {
    f && r2 && r2.recordStreamInit(f, !e4, new Date().getTime() - f), f = null;
  }
  return a2.connect = function(e4, t3, n3) {
    m2 = e4, h2 = t3, y2 = {};
    for (const e5 in n3 || {})
      y2[e5] = function(t4) {
        g = false, C2(true), n3[e5] && n3[e5](t4);
      };
    E2();
  }, a2.disconnect = function() {
    clearTimeout(p), p = null, x2();
  }, a2.isConnected = function() {
    return !!(v && e3.eventSourceIsActive && e3.eventSourceIsActive(v));
  }, a2;
};
var Be = function(e3) {
  let t2, n2, r2, o2;
  const i2 = { addPromise: (i3, a2) => {
    t2 = i3, n2 && n2(), n2 = a2, i3.then((n3) => {
      t2 === i3 && (r2(n3), e3 && e3());
    }, (n3) => {
      t2 === i3 && (o2(n3), e3 && e3());
    });
  } };
  return i2.resultPromise = new Promise((e4, t3) => {
    r2 = e4, o2 = t3;
  }), i2;
};
const { transformHeaders: Ge, getLDHeaders: We } = ge, Xe = "application/json";
var Qe = function(e3, t2, n2) {
  const r2 = t2.baseUrl, o2 = t2.useReport, i2 = t2.evaluationReasons, a2 = t2.logger, c = {}, u = {};
  function l(n3, r3) {
    if (!e3.httpRequest)
      return new Promise((e4, t3) => {
        t3(new s.LDFlagFetchError(ie.httpUnavailable()));
      });
    const o3 = r3 ? "REPORT" : "GET", i3 = We(e3, t2);
    r3 && (i3["Content-Type"] = Xe);
    let a3 = u[n3];
    a3 || (a3 = Be(() => {
      delete u[n3];
    }), u[n3] = a3);
    const c2 = e3.httpRequest(o3, n3, Ge(i3, t2), r3), l2 = c2.promise.then((e4) => {
      if (200 === e4.status) {
        if (e4.header("content-type") && e4.header("content-type").substring(0, 16) === Xe)
          return JSON.parse(e4.body);
        {
          const t3 = ie.invalidContentType(e4.header("content-type") || "");
          return Promise.reject(new s.LDFlagFetchError(t3));
        }
      }
      return Promise.reject(function(e5) {
        return 404 === e5.status ? new s.LDInvalidEnvironmentIdError(ie.environmentNotFound()) : new s.LDFlagFetchError(ie.errorFetchingFlags(e5.statusText || String(e5.status)));
      }(e4));
    }, (e4) => Promise.reject(new s.LDFlagFetchError(ie.networkError(e4))));
    return a3.addPromise(l2, () => {
      c2.cancel && c2.cancel();
    }), a3.resultPromise;
  }
  return c.fetchJSON = function(e4) {
    return l(S.appendUrlPath(r2, e4), null);
  }, c.fetchFlagSettings = function(e4, t3) {
    let s, c2, u2, d = "";
    return o2 ? (c2 = [r2, "/sdk/evalx/", n2, "/context"].join(""), u2 = JSON.stringify(e4)) : (s = S.base64URLEncode(JSON.stringify(e4)), c2 = [r2, "/sdk/evalx/", n2, "/contexts/", s].join("")), t3 && (d = "h=" + t3), i2 && (d = d + (d ? "&" : "") + "withReasons=true"), c2 = c2 + (d ? "?" : "") + d, a2.debug(ie.debugPolling(c2)), l(c2, u2);
  }, c;
};
var Ye = function(e3, t2) {
  const n2 = {};
  let r2;
  return n2.setContext = function(e4) {
    r2 = S.sanitizeContext(e4), r2 && t2 && t2(S.clone(r2));
  }, n2.getContext = function() {
    return r2 ? S.clone(r2) : null;
  }, e3 && n2.setContext(e3), n2;
};
const { v1: Ze } = ee, { getContextKinds: et } = ke;
var tt = function(e3) {
  function t2(e4) {
    return null == e4 || "user" === e4 ? "ld:$anonUserId" : `ld:$contextKey:${e4}`;
  }
  function n2(n3, r2) {
    return null !== r2.key && void 0 !== r2.key ? (r2.key = r2.key.toString(), Promise.resolve(r2)) : r2.anonymous ? function(n4) {
      return e3.get(t2(n4));
    }(n3).then((o2) => {
      if (o2)
        return r2.key = o2, r2;
      {
        const o3 = Ze();
        return r2.key = o3, function(n4, r3) {
          return e3.set(t2(r3), n4);
        }(o3, n3).then(() => r2);
      }
    }) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
  }
  this.processContext = (e4) => {
    if (!e4)
      return Promise.reject(new s.LDInvalidUserError(ie.contextNotSpecified()));
    const t3 = S.clone(e4);
    if ("multi" === e4.kind) {
      const e5 = et(t3);
      return Promise.all(e5.map((e6) => n2(e6, t3[e6]))).then(() => t3);
    }
    return n2(e4.kind, t3);
  };
};
const { v1: nt } = ee, { baseOptionDefs: rt } = de, { appendUrlPath: ot } = S;
var it = { DiagnosticId: function(e3) {
  const t2 = { diagnosticId: nt() };
  return e3 && (t2.sdkKeySuffix = e3.length > 6 ? e3.substring(e3.length - 6) : e3), t2;
}, DiagnosticsAccumulator: function(e3) {
  let t2, n2, r2, o2;
  function i2(e4) {
    t2 = e4, n2 = 0, r2 = 0, o2 = [];
  }
  return i2(e3), { getProps: () => ({ dataSinceDate: t2, droppedEvents: n2, eventsInLastBatch: r2, streamInits: o2 }), setProps: (e4) => {
    t2 = e4.dataSinceDate, n2 = e4.droppedEvents || 0, r2 = e4.eventsInLastBatch || 0, o2 = e4.streamInits || [];
  }, incrementDroppedEvents: () => {
    n2++;
  }, setEventsInLastBatch: (e4) => {
    r2 = e4;
  }, recordStreamInit: (e4, t3, n3) => {
    const r3 = { timestamp: e4, failed: t3, durationMillis: n3 };
    o2.push(r3);
  }, reset: i2 };
}, DiagnosticsManager: function(e3, t2, n2, r2, o2, i2, a2) {
  const s = !!e3.diagnosticUseCombinedEvent, c = "ld:" + o2 + ":$diagnostics", u = ot(i2.eventsUrl, "/events/diagnostic/" + o2), l = i2.diagnosticRecordingInterval, d = n2;
  let f, g, v = !!i2.streaming;
  const p = {};
  function m2() {
    return { sdk: w2(), configuration: b2(), platform: e3.diagnosticPlatformData };
  }
  function h2(e4) {
    i2.logger && i2.logger.debug(ie.debugPostingDiagnosticEvent(e4)), r2.sendEvents(e4, u, true).then(() => {
    }).catch(() => {
    });
  }
  function y2() {
    h2(function() {
      const e4 = new Date().getTime();
      let t3 = { kind: s ? "diagnostic-combined" : "diagnostic", id: a2, creationDate: e4, ...d.getProps() };
      return s && (t3 = { ...t3, ...m2() }), d.reset(e4), t3;
    }()), g = setTimeout(y2, l), f = new Date().getTime(), s && function() {
      if (t2.isEnabled()) {
        const e4 = { ...d.getProps() };
        t2.set(c, JSON.stringify(e4));
      }
    }();
  }
  function w2() {
    const t3 = { ...e3.diagnosticSdkData };
    return i2.wrapperName && (t3.wrapperName = i2.wrapperName), i2.wrapperVersion && (t3.wrapperVersion = i2.wrapperVersion), t3;
  }
  function b2() {
    return { customBaseURI: i2.baseUrl !== rt.baseUrl.default, customStreamURI: i2.streamUrl !== rt.streamUrl.default, customEventsURI: i2.eventsUrl !== rt.eventsUrl.default, eventsCapacity: i2.eventCapacity, eventsFlushIntervalMillis: i2.flushInterval, reconnectTimeMillis: i2.streamReconnectDelay, streamingDisabled: !v, allAttributesPrivate: !!i2.allAttributesPrivate, diagnosticRecordingIntervalMillis: i2.diagnosticRecordingInterval, usingSecureMode: !!i2.hash, bootstrapMode: !!i2.bootstrap, fetchGoalsDisabled: !i2.fetchGoals, sendEventsOnlyForVariation: !!i2.sendEventsOnlyForVariation };
  }
  return p.start = () => {
    s ? function(e4) {
      if (!t2.isEnabled())
        return e4(false);
      t2.get(c).then((t3) => {
        if (t3)
          try {
            const e5 = JSON.parse(t3);
            d.setProps(e5), f = e5.dataSinceDate;
          } catch (e5) {
          }
        e4(true);
      }).catch(() => {
        e4(false);
      });
    }((e4) => {
      if (e4) {
        const e5 = (f || 0) + l, t3 = new Date().getTime();
        t3 >= e5 ? y2() : g = setTimeout(y2, e5 - t3);
      } else
        0 === Math.floor(4 * Math.random()) ? y2() : g = setTimeout(y2, l);
    }) : (h2({ kind: "diagnostic-init", id: a2, creationDate: d.getProps().dataSinceDate, ...m2() }), g = setTimeout(y2, l));
  }, p.stop = () => {
    g && clearTimeout(g);
  }, p.setStreaming = (e4) => {
    v = e4;
  }, p;
} };
var at = function(e3, t2) {
  let n2 = false;
  const r2 = { type: e3.type, name: e3.name, method: (...o2) => {
    try {
      e3.method(...o2);
    } catch {
      n2 || (n2 = true, t2.warn(ie.inspectorMethodError(r2.type, r2.name)));
    }
  } };
  return r2;
};
const { onNextTick: st } = S, ct = { flagUsed: "flag-used", flagDetailsChanged: "flag-details-changed", flagDetailChanged: "flag-detail-changed", clientIdentityChanged: "client-identity-changed" };
Object.freeze(ct);
var ut = { InspectorTypes: ct, InspectorManager: function(e3, t2) {
  const n2 = {}, r2 = { [ct.flagUsed]: [], [ct.flagDetailsChanged]: [], [ct.flagDetailChanged]: [], [ct.clientIdentityChanged]: [] }, o2 = e3 && e3.map((e4) => at(e4, t2));
  return o2 && o2.forEach((e4) => {
    Object.prototype.hasOwnProperty.call(r2, e4.type) ? r2[e4.type].push(e4) : t2.warn(ie.invalidInspector(e4.type, e4.name));
  }), n2.hasListeners = (e4) => r2[e4] && r2[e4].length, n2.onFlagUsed = (e4, t3, n3) => {
    r2[ct.flagUsed].length && st(() => {
      r2[ct.flagUsed].forEach((r3) => r3.method(e4, t3, n3));
    });
  }, n2.onFlags = (e4) => {
    r2[ct.flagDetailsChanged].length && st(() => {
      r2[ct.flagDetailsChanged].forEach((t3) => t3.method(e4));
    });
  }, n2.onFlagChanged = (e4, t3) => {
    r2[ct.flagDetailChanged].length && st(() => {
      r2[ct.flagDetailChanged].forEach((n3) => n3.method(e4, t3));
    });
  }, n2.onIdentityChanged = (e4) => {
    r2[ct.clientIdentityChanged].length && st(() => {
      r2[ct.clientIdentityChanged].forEach((t3) => t3.method(e4));
    });
  }, n2;
} };
const { LDTimeoutError: lt } = s;
var dt = function(e3, t2) {
  return new Promise((n2, r2) => {
    setTimeout(() => {
      r2(new lt(`${t2} timed out after ${e3} seconds.`));
    }, 1e3 * e3);
  });
};
const { commonBasicLogger: ft } = ne, { checkContext: gt, getContextKeys: vt } = ke, { InspectorTypes: pt, InspectorManager: mt } = ut, ht = "change", yt = "internal-change";
var wt = { initialize: function(e3, t2, n2, r2, o2) {
  const i2 = function() {
    if (n2 && n2.logger)
      return n2.logger;
    return o2 && o2.logger && o2.logger.default || ft("warn");
  }(), a2 = Re(i2), c = Ne(a2), u = de.validate(n2, a2, o2, i2), l = mt(u.inspectors, i2), d = u.sendEvents;
  let f = e3, g = u.hash;
  const v = Ve(r2.localStorage, i2), p = he(r2, f, u), m2 = u.sendEvents && !u.diagnosticOptOut, h2 = m2 ? it.DiagnosticId(f) : null, y2 = m2 ? it.DiagnosticsAccumulator(new Date().getTime()) : null, w2 = m2 ? it.DiagnosticsManager(r2, v, y2, p, f, u, h2) : null, b2 = Je(r2, u, f, y2), k2 = u.eventProcessor || Ue(r2, u, f, y2, a2, p), E2 = Qe(r2, u, f);
  let D2, x2, C2, P2 = {}, I2 = u.streaming, O2 = false, T2 = false, L2 = true;
  const U = u.stateProvider, R = Ye(null, function(e4) {
    (function(e5) {
      if (U)
        return;
      e5 && F2({ kind: "identify", context: e5, creationDate: new Date().getTime() });
    })(e4), l.hasListeners(pt.clientIdentityChanged) && l.onIdentityChanged(R.getContext());
  }), A = new tt(v), j = v.isEnabled() ? $e(v, f, g, R) : null;
  function F2(e4) {
    f && (U && U.enqueueEvent && U.enqueueEvent(e4) || (e4.context ? (L2 = false, !d || T2 || r2.isDoNotTrack() || (i2.debug(ie.debugEnqueueingEvent(e4.kind)), k2.enqueue(e4))) : L2 && (i2.warn(ie.eventWithoutContext()), L2 = false)));
  }
  function N2(e4, t3) {
    l.hasListeners(pt.flagDetailChanged) && l.onFlagChanged(e4.key, q2(t3));
  }
  function $2() {
    l.hasListeners(pt.flagDetailsChanged) && l.onFlags(Object.entries(P2).map(([e4, t3]) => ({ key: e4, detail: q2(t3) })).reduce((e4, t3) => (e4[t3.key] = t3.detail, e4), {}));
  }
  function V2(e4, t3, n3, r3) {
    const o3 = R.getContext(), i3 = new Date(), a3 = { kind: "feature", key: e4, context: o3, value: t3 ? t3.value : null, variation: t3 ? t3.variationIndex : null, default: n3, creationDate: i3.getTime() }, s = P2[e4];
    s && (a3.version = s.flagVersion ? s.flagVersion : s.version, a3.trackEvents = s.trackEvents, a3.debugEventsUntilDate = s.debugEventsUntilDate), (r3 || s && s.trackReason) && t3 && (a3.reason = t3.reason), F2(a3);
  }
  function M2(e4) {
    return gt(e4, false) ? Promise.resolve(e4) : Promise.reject(new s.LDInvalidUserError(ie.invalidContext()));
  }
  function H2(e4, t3, n3, r3, o3) {
    let i3;
    if (P2 && S.objectHasOwnProperty(P2, e4) && P2[e4] && !P2[e4].deleted) {
      const n4 = P2[e4];
      i3 = q2(n4), null !== n4.value && void 0 !== n4.value || (i3.value = t3);
    } else
      i3 = { value: t3, variationIndex: null, reason: { kind: "ERROR", errorKind: "FLAG_NOT_FOUND" } };
    return n3 && V2(e4, i3, t3, r3), o3 || function(e5, t4) {
      l.hasListeners(pt.flagUsed) && l.onFlagUsed(e5, t4, R.getContext());
    }(e4, i3), i3;
  }
  function q2(e4) {
    return { value: e4.value, variationIndex: void 0 === e4.variation ? null : e4.variation, reason: e4.reason || null };
  }
  function z2() {
    if (x2 = true, !R.getContext())
      return;
    const e4 = (e5) => {
      try {
        return JSON.parse(e5);
      } catch (e6) {
        return void a2.maybeReportError(new s.LDInvalidDataError(ie.invalidData()));
      }
    };
    b2.connect(R.getContext(), g, { ping: function() {
      i2.debug(ie.debugStreamPing());
      const e5 = R.getContext();
      E2.fetchFlagSettings(e5, g).then((t3) => {
        S.deepEquals(e5, R.getContext()) && _2(t3 || {});
      }).catch((e6) => {
        a2.maybeReportError(new s.LDFlagFetchError(ie.errorFetchingFlags(e6)));
      });
    }, put: function(t3) {
      const n3 = e4(t3.data);
      n3 && (i2.debug(ie.debugStreamPut()), _2(n3));
    }, patch: function(t3) {
      const n3 = e4(t3.data);
      if (!n3)
        return;
      const r3 = P2[n3.key];
      if (!r3 || !r3.version || !n3.version || r3.version < n3.version) {
        i2.debug(ie.debugStreamPatch(n3.key));
        const e5 = {}, t4 = S.extend({}, n3);
        delete t4.key, P2[n3.key] = t4;
        const o3 = q2(t4);
        e5[n3.key] = r3 ? { previous: r3.value, current: o3 } : { current: o3 }, J2(e5), N2(n3, t4);
      } else
        i2.debug(ie.debugStreamPatchIgnored(n3.key));
    }, delete: function(t3) {
      const n3 = e4(t3.data);
      if (n3)
        if (!P2[n3.key] || P2[n3.key].version < n3.version) {
          i2.debug(ie.debugStreamDelete(n3.key));
          const e5 = {};
          P2[n3.key] && !P2[n3.key].deleted && (e5[n3.key] = { previous: P2[n3.key].value }), P2[n3.key] = { version: n3.version, deleted: true }, N2(n3, P2[n3.key]), J2(e5);
        } else
          i2.debug(ie.debugStreamDeleteIgnored(n3.key));
    } });
  }
  function K2() {
    x2 && (b2.disconnect(), x2 = false);
  }
  function _2(e4) {
    const t3 = {};
    if (!e4)
      return Promise.resolve();
    for (const n3 in P2)
      S.objectHasOwnProperty(P2, n3) && P2[n3] && (e4[n3] && !S.deepEquals(e4[n3].value, P2[n3].value) ? t3[n3] = { previous: P2[n3].value, current: q2(e4[n3]) } : e4[n3] && !e4[n3].deleted || (t3[n3] = { previous: P2[n3].value }));
    for (const n3 in e4)
      S.objectHasOwnProperty(e4, n3) && e4[n3] && (!P2[n3] || P2[n3].deleted) && (t3[n3] = { current: q2(e4[n3]) });
    return P2 = { ...e4 }, $2(), J2(t3).catch(() => {
    });
  }
  function J2(e4) {
    const t3 = Object.keys(e4);
    if (t3.length > 0) {
      const n3 = {};
      t3.forEach((t4) => {
        const r3 = e4[t4].current, o3 = r3 ? r3.value : void 0, i3 = e4[t4].previous;
        a2.emit(ht + ":" + t4, o3, i3), n3[t4] = r3 ? { current: o3, previous: i3 } : { previous: i3 };
      }), a2.emit(ht, n3), a2.emit(yt, P2), u.sendEventsOnlyForVariation || U || t3.forEach((t4) => {
        V2(t4, e4[t4].current);
      });
    }
    return D2 && j ? j.saveFlags(P2) : Promise.resolve();
  }
  function B2() {
    const e4 = I2 || C2 && void 0 === I2;
    e4 && !x2 ? z2() : !e4 && x2 && K2(), w2 && w2.setStreaming(e4);
  }
  function G2(e4) {
    return e4 === ht || e4.substr(0, 7) === ht + ":";
  }
  if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (j ? D2 = true : i2.warn(ie.localStorageUnavailable())), "object" == typeof u.bootstrap && (P2 = function(e4) {
    const t3 = Object.keys(e4), n3 = "$flagsState", r3 = "$valid", o3 = e4[n3];
    !o3 && t3.length && i2.warn(ie.bootstrapOldFormat()), false === e4[r3] && i2.warn(ie.bootstrapInvalid());
    const a3 = {};
    return t3.forEach((t4) => {
      if (t4 !== n3 && t4 !== r3) {
        let n4 = { value: e4[t4] };
        o3 && o3[t4] ? n4 = S.extend(n4, o3[t4]) : n4.version = 0, a3[t4] = n4;
      }
    }), a3;
  }(u.bootstrap)), U) {
    const e4 = U.getInitialState();
    e4 ? W2(e4) : U.on("init", W2), U.on("update", function(e5) {
      e5.context && R.setContext(e5.context);
      e5.flags && _2(e5.flags);
    });
  } else
    (function() {
      if (!e3)
        return Promise.reject(new s.LDInvalidEnvironmentIdError(ie.environmentNotSpecified()));
      return A.processContext(t2).then(M2).then((e4) => (R.setContext(e4), "object" == typeof u.bootstrap ? X2() : D2 ? j.loadFlags().then((e5) => null == e5 ? (P2 = {}, E2.fetchFlagSettings(R.getContext(), g).then((e6) => _2(e6 || {})).then(X2).catch((e6) => {
        Q2(new s.LDFlagFetchError(ie.errorFetchingFlags(e6)));
      })) : (P2 = e5, S.onNextTick(X2), E2.fetchFlagSettings(R.getContext(), g).then((e6) => _2(e6)).catch((e6) => a2.maybeReportError(e6)))) : E2.fetchFlagSettings(R.getContext(), g).then((e5) => {
        P2 = e5 || {}, $2(), X2();
      }).catch((e5) => {
        P2 = {}, Q2(e5);
      })));
    })().catch(Q2);
  function W2(e4) {
    f = e4.environment, R.setContext(e4.context), P2 = { ...e4.flags }, S.onNextTick(X2);
  }
  function X2() {
    i2.info(ie.clientInitialized()), O2 = true, B2(), c.signalSuccess();
  }
  function Q2(e4) {
    c.signalFailure(e4);
  }
  const Y2 = { waitForInitialization: function(e4 = void 0) {
    if (null != e4) {
      if ("number" == typeof e4)
        return function(e5) {
          e5 > 5 && i2.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
          const t3 = c.getInitializationPromise(), n3 = dt(e5, "waitForInitialization");
          return Promise.race([n3, t3]).catch((e6) => {
            throw e6 instanceof s.LDTimeoutError && i2.error(`waitForInitialization error: ${e6}`), e6;
          });
        }(e4);
      i2.warn("The waitForInitialization method was provided with a non-numeric timeout.");
    }
    return i2.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
  }, waitUntilReady: () => c.getReadyPromise(), identify: function(e4, t3, n3) {
    if (T2)
      return S.wrapPromiseCallback(Promise.resolve({}), n3);
    if (U)
      return i2.warn(ie.identifyDisabled()), S.wrapPromiseCallback(Promise.resolve(S.transformVersionedValuesToValues(P2)), n3);
    const r3 = D2 && j ? j.clearFlags() : Promise.resolve();
    return S.wrapPromiseCallback(r3.then(() => A.processContext(e4)).then(M2).then((e5) => E2.fetchFlagSettings(e5, t3).then((n4) => {
      const r4 = S.transformVersionedValuesToValues(n4);
      return R.setContext(e5), g = t3, n4 ? _2(n4).then(() => r4) : r4;
    })).then((e5) => (x2 && z2(), e5)).catch((e5) => (a2.maybeReportError(e5), Promise.reject(e5))), n3);
  }, getContext: function() {
    return R.getContext();
  }, variation: function(e4, t3) {
    return H2(e4, t3, true, false, false).value;
  }, variationDetail: function(e4, t3) {
    return H2(e4, t3, true, true, false);
  }, track: function(e4, t3, n3) {
    if ("string" != typeof e4)
      return void a2.maybeReportError(new s.LDInvalidEventKeyError(ie.unknownCustomEventKey(e4)));
    void 0 !== n3 && "number" != typeof n3 && i2.warn(ie.invalidMetricValue(typeof n3)), r2.customEventFilter && !r2.customEventFilter(e4) && i2.warn(ie.unknownCustomEventKey(e4));
    const o3 = R.getContext(), c2 = { kind: "custom", key: e4, context: o3, url: r2.getCurrentUrl(), creationDate: new Date().getTime() };
    o3 && o3.anonymous && (c2.contextKind = o3.anonymous ? "anonymousUser" : "user"), null != t3 && (c2.data = t3), null != n3 && (c2.metricValue = n3), F2(c2);
  }, on: function(e4, t3, n3) {
    G2(e4) ? (C2 = true, O2 && B2(), a2.on(e4, t3, n3)) : a2.on(...arguments);
  }, off: function(e4) {
    if (a2.off(...arguments), G2(e4)) {
      let e5 = false;
      a2.getEvents().forEach((t3) => {
        G2(t3) && a2.getEventListenerCount(t3) > 0 && (e5 = true);
      }), e5 || (C2 = false, x2 && void 0 === I2 && K2());
    }
  }, setStreaming: function(e4) {
    const t3 = null === e4 ? void 0 : e4;
    t3 !== I2 && (I2 = t3, B2());
  }, flush: function(e4) {
    return S.wrapPromiseCallback(d ? k2.flush() : Promise.resolve(), e4);
  }, allFlags: function() {
    const e4 = {};
    if (!P2)
      return e4;
    for (const t3 in P2)
      S.objectHasOwnProperty(P2, t3) && !P2[t3].deleted && (e4[t3] = H2(t3, null, !u.sendEventsOnlyForVariation, false, true).value);
    return e4;
  }, close: function(e4) {
    if (T2)
      return S.wrapPromiseCallback(Promise.resolve(), e4);
    const t3 = () => {
      T2 = true, P2 = {};
    }, n3 = Promise.resolve().then(() => {
      if (K2(), w2 && w2.stop(), d)
        return k2.stop(), k2.flush();
    }).then(t3).catch(t3);
    return S.wrapPromiseCallback(n3, e4);
  } };
  return { client: Y2, options: u, emitter: a2, ident: R, logger: i2, requestor: E2, start: function() {
    d && (w2 && w2.start(), k2.start());
  }, enqueueEvent: F2, getFlagsInternal: function() {
    return P2;
  }, getEnvironmentId: () => f, internalChangeEventName: yt };
}, commonBasicLogger: ft, errors: s, messages: ie, utils: S, getContextKeys: vt }, bt = wt.initialize, kt = wt.errors;
function Dt(e3, t2) {
  var n2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var r2 = Object.getOwnPropertySymbols(e3);
    t2 && (r2 = r2.filter(function(t3) {
      return Object.getOwnPropertyDescriptor(e3, t3).enumerable;
    })), n2.push.apply(n2, r2);
  }
  return n2;
}
function xt(e3) {
  for (var t2 = 1; t2 < arguments.length; t2++) {
    var n2 = null != arguments[t2] ? arguments[t2] : {};
    t2 % 2 ? Dt(Object(n2), true).forEach(function(t3) {
      Pt(e3, t3, n2[t3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(n2)) : Dt(Object(n2)).forEach(function(t3) {
      Object.defineProperty(e3, t3, Object.getOwnPropertyDescriptor(n2, t3));
    });
  }
  return e3;
}
function Ct(e3) {
  var t2 = function(e4, t3) {
    if ("object" != typeof e4 || !e4)
      return e4;
    var n2 = e4[Symbol.toPrimitive];
    if (void 0 !== n2) {
      var r2 = n2.call(e4, t3 || "default");
      if ("object" != typeof r2)
        return r2;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t3 ? String : Number)(e4);
  }(e3, "string");
  return "symbol" == typeof t2 ? t2 : t2 + "";
}
function Pt(e3, t2, n2) {
  return (t2 = Ct(t2)) in e3 ? Object.defineProperty(e3, t2, { value: n2, enumerable: true, configurable: true, writable: true }) : e3[t2] = n2, e3;
}
var Ot = { promise: Promise.resolve({ status: 200, header: function() {
  return null;
}, body: null }) };
function Tt(e3, t2, n2, r2, o2) {
  if (o2 && !function() {
    var e4 = window.navigator && window.navigator.userAgent;
    if (e4) {
      var t3 = e4.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (t3)
        return parseInt(t3[2], 10) < 73;
    }
    return true;
  }())
    return Ot;
  var i2 = new window.XMLHttpRequest();
  for (var a2 in i2.open(e3, t2, !o2), n2 || {})
    Object.prototype.hasOwnProperty.call(n2, a2) && i2.setRequestHeader(a2, n2[a2]);
  if (o2) {
    try {
      i2.send(r2);
    } catch (e4) {
    }
    return Ot;
  }
  var s, c = new Promise(function(e4, t3) {
    i2.addEventListener("load", function() {
      s || e4({ status: i2.status, header: function(e5) {
        return i2.getResponseHeader(e5);
      }, body: i2.responseText });
    }), i2.addEventListener("error", function() {
      s || t3(new Error());
    }), i2.send(r2);
  });
  return { promise: c, cancel: function() {
    s = true, i2.abort();
  } };
}
var Lt = (e3) => {
  if ("string" != typeof e3)
    throw new TypeError("Expected a string");
  return e3.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Ut(e3, t2, n2, r2) {
  var o2, i2, a2 = (("substring" === e3.kind || "regex" === e3.kind) && r2.includes("/") ? t2 : t2.replace(r2, "")).replace(n2, "");
  switch (e3.kind) {
    case "exact":
      i2 = t2, o2 = new RegExp("^" + Lt(e3.url) + "/?$");
      break;
    case "canonical":
      i2 = a2, o2 = new RegExp("^" + Lt(e3.url) + "/?$");
      break;
    case "substring":
      i2 = a2, o2 = new RegExp(".*" + Lt(e3.substring) + ".*$");
      break;
    case "regex":
      i2 = a2, o2 = new RegExp(e3.pattern);
      break;
    default:
      return false;
  }
  return o2.test(i2);
}
function Rt(e3, t2) {
  for (var n2 = {}, r2 = null, o2 = [], i2 = 0; i2 < e3.length; i2++)
    for (var a2 = e3[i2], s = a2.urls || [], c = 0; c < s.length; c++)
      if (Ut(s[c], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a2.kind ? t2("pageview", a2) : (o2.push(a2), t2("click_pageview", a2));
        break;
      }
  return o2.length > 0 && (r2 = function(e4) {
    for (var n3 = function(e5, t3) {
      for (var n4 = [], r4 = 0; r4 < t3.length; r4++)
        for (var o3 = e5.target, i3 = t3[r4], a3 = i3.selector, s2 = document.querySelectorAll(a3); o3 && s2.length > 0; ) {
          for (var c2 = 0; c2 < s2.length; c2++)
            o3 === s2[c2] && n4.push(i3);
          o3 = o3.parentNode;
        }
      return n4;
    }(e4, o2), r3 = 0; r3 < n3.length; r3++)
      t2("click", n3[r3]);
  }, document.addEventListener("click", r2)), n2.dispose = function() {
    document.removeEventListener("click", r2);
  }, n2;
}
var At = 300;
function jt(e3, t2) {
  var n2, r2;
  function o2() {
    r2 && r2.dispose(), n2 && n2.length && (r2 = Rt(n2, i2));
  }
  function i2(t3, n3) {
    var r3 = e3.ident.getContext(), o3 = { kind: t3, key: n3.key, data: null, url: window.location.href, creationDate: new Date().getTime(), context: r3 };
    return "click" === t3 && (o3.selector = n3.selector), e3.enqueueEvent(o3);
  }
  return e3.requestor.fetchJSON("/sdk/goals/" + e3.getEnvironmentId()).then(function(e4) {
    e4 && e4.length > 0 && (r2 = Rt(n2 = e4, i2), function(e5, t3) {
      var n3, r3 = window.location.href;
      function o3() {
        (n3 = window.location.href) !== r3 && (r3 = n3, t3());
      }
      !function e6(t4, n4) {
        t4(), setTimeout(function() {
          e6(t4, n4);
        }, n4);
      }(o3, e5), window.history && window.history.pushState ? window.addEventListener("popstate", o3) : window.addEventListener("hashchange", o3);
    }(At, o2)), t2();
  }).catch(function(n3) {
    e3.emitter.maybeReportError(new kt.LDUnexpectedResponseError((n3 && n3.message, n3.message))), t2();
  }), {};
}
var Ft = "goalsReady", Nt = { fetchGoals: { default: true }, hash: { type: "string" }, eventProcessor: { type: "object" }, eventUrlTransformer: { type: "function" }, disableSyncEventPost: { default: false } };
function $t(e3, t2) {
  var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r2 = function(e4) {
    var t3, n3 = { userAgentHeaderName: "X-LaunchDarkly-User-Agent", synchronousFlush: false };
    if (window.XMLHttpRequest) {
      var r3 = e4 && e4.disableSyncEventPost;
      n3.httpRequest = function(e5, t4, o4, i4) {
        var a4 = n3.synchronousFlush & !r3;
        return n3.synchronousFlush = false, Tt(e5, t4, o4, i4, a4);
      };
    }
    n3.httpAllowsPost = function() {
      return void 0 === t3 && (t3 = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), t3;
    }, n3.httpFallbackPing = function(e5) {
      new window.Image().src = e5;
    };
    var o3, i3 = e4 && e4.eventUrlTransformer;
    n3.getCurrentUrl = function() {
      return i3 ? i3(window.location.href) : window.location.href;
    }, n3.isDoNotTrack = function() {
      var e5;
      return 1 === (e5 = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || true === e5 || "1" === e5 || "yes" === e5;
    };
    try {
      window.localStorage && (n3.localStorage = { get: function(e5) {
        return new Promise(function(t4) {
          t4(window.localStorage.getItem(e5));
        });
      }, set: function(e5, t4) {
        return new Promise(function(n4) {
          window.localStorage.setItem(e5, t4), n4();
        });
      }, clear: function(e5) {
        return new Promise(function(t4) {
          window.localStorage.removeItem(e5), t4();
        });
      } });
    } catch (e5) {
      n3.localStorage = null;
    }
    if (e4 && e4.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n3.eventSourceAllowsReport = true, o3 = window.EventSourcePolyfill) : (n3.eventSourceAllowsReport = false, o3 = window.EventSource), window.EventSource) {
      var a3 = 3e5;
      n3.eventSourceFactory = function(e5, t4) {
        var n4 = xt(xt({}, { heartbeatTimeout: a3, silentTimeout: a3, skipDefaultHeaders: true }), t4);
        return new o3(e5, n4);
      }, n3.eventSourceIsActive = function(e5) {
        return e5.readyState === window.EventSource.OPEN || e5.readyState === window.EventSource.CONNECTING;
      };
    }
    return n3.userAgent = "JSClient", n3.version = "3.3.0", n3.diagnosticSdkData = { name: "js-client-sdk", version: "3.3.0" }, n3.diagnosticPlatformData = { name: "JS" }, n3.diagnosticUseCombinedEvent = true, n3;
  }(n2), o2 = bt(e3, t2, n2, r2, Nt), i2 = o2.client, a2 = o2.options, s = o2.emitter, c = new Promise(function(e4) {
    var t3 = s.on(Ft, function() {
      s.off(Ft, t3), e4();
    });
  });
  i2.waitUntilGoalsReady = function() {
    return c;
  }, a2.fetchGoals ? jt(o2, function() {
    return s.emit(Ft);
  }) : s.emit(Ft), "complete" !== document.readyState ? window.addEventListener("load", o2.start) : o2.start();
  var u = function() {
    r2.synchronousFlush = true, i2.flush().catch(function() {
    }), r2.synchronousFlush = false;
  };
  return document.addEventListener("visibilitychange", function() {
    "hidden" === document.visibilityState && u();
  }), window.addEventListener("pagehide", u), i2;
}
const getLDFlag = (ldReady, $ldClient, enableStreaming = true) => {
  return function ldFlag(flagKey, defaultFlagValue) {
    const isLdReady = ldReady.value;
    const flagValue = isLdReady ? $ldClient.variation(flagKey, defaultFlagValue) : defaultFlagValue;
    const flagRef = ref(flagValue);
    if (!enableStreaming) {
      return readonly(flagRef);
    }
    const updateFlagRef = (newFlagValue) => flagRef.value = newFlagValue;
    $ldClient.on(`change:${flagKey}`, updateFlagRef);
    onBeforeUnmount(() => $ldClient.off(`change:${flagKey}`, updateFlagRef));
    if (!isLdReady) {
      $ldClient.on("ready", () => updateFlagRef($ldClient.variation(flagKey, flagRef.value)));
    }
    return readonly(flagRef);
  };
};
const version = "2.2.0";
const getContextOrUser = (config) => {
  var _a;
  return (_a = config.context) != null ? _a : config.user;
};
const safeInject = (key, label) => {
  const target = inject(key);
  if (target === void 0) {
    throw new Error(`Injection of ${label} failed. LaunchDarkly plugin may not have been loaded.`);
  }
  return target;
};
function useLDReady() {
  return safeInject(LD_READY, "LD_READY");
}
function useLDClient() {
  return safeInject(LD_CLIENT, "LD_CLIENT");
}
function ldInit(initOptions) {
  return safeInject(LD_INIT, "LD_INIT")(initOptions);
}
function useLDFlag(flagKey, defaultValue) {
  return safeInject(LD_FLAG, "LD_FLAG")(flagKey, defaultValue);
}
const LD_INIT = Symbol();
const LD_READY = Symbol();
const LD_CLIENT = Symbol();
const LD_FLAG = Symbol();
const LDPlugin = {
  install(app, pluginOptions = {}) {
    const ldReady = ref(false);
    const $ldReady = readonly(ldReady);
    const $ldInit = (initOptions = {}) => {
      var _a, _b, _c, _d;
      const clientSideID = (_a = initOptions.clientSideID) != null ? _a : pluginOptions.clientSideID;
      if (!clientSideID) {
        throw new Error(`Cannot initialize LaunchDarkly without a clientSideID`);
      }
      const context = (_c = (_b = getContextOrUser(initOptions)) != null ? _b : getContextOrUser(pluginOptions)) != null ? _c : { anonymous: true, kind: "user" };
      const options = (_d = initOptions.options) != null ? _d : pluginOptions.options;
      const wrapperOptions = { wrapperName: "vue-client-sdk", wrapperVersion: version };
      const $ldClient = $t(clientSideID, context, { ...wrapperOptions, ...options });
      app.provide(LD_CLIENT, $ldClient);
      const enableStreaming = pluginOptions.streaming === false || initOptions.streaming === false ? false : true;
      app.provide(LD_FLAG, getLDFlag(ldReady, $ldClient, enableStreaming));
      $ldClient.on("ready", () => ldReady.value = true);
      return [$ldReady, $ldClient];
    };
    app.provide(LD_READY, $ldReady);
    if (pluginOptions.deferInitialization) {
      app.provide(LD_INIT, $ldInit);
    } else if (!pluginOptions.clientSideID) {
      throw new Error("LaunchDarkly plugin requires a clientSideID unless deferInitialization option is used");
    } else {
      $ldInit(pluginOptions);
    }
  }
};
export { LDPlugin, LD_CLIENT, LD_FLAG, LD_INIT, LD_READY, ldInit, useLDClient, useLDFlag, useLDReady };
